import { Expose, Transform } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsBuddi extends SnModel {
  @Expose({ name: 'id' })
  @Transform((value) => value?.toString())
  public id: string;

  @Expose({ name: 'first_name' })
  public firstName: string;

  @Expose({ name: 'fix_distance' })
  public fixDistance: number;

  @Expose({ name: 'fix_lat' })
  public fixLat: number;

  @Expose({ name: 'fix_lon' })
  public fixLon: number;

  @Expose({ name: 'fix_timestamp' })
  public fixTimestamp: string;

  @Expose()
  public ref: any;

  @Expose()
  public surname: string;

  @Expose({ name: 'wearer_group' })
  public wearerGroup: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
